var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme_.container,style:(_vm.styles),attrs:{"title":_vm.title},domProps:{"innerHTML":_vm._s(_vm.icon)}})
}
var staticRenderFns = []

export { render, staticRenderFns }